import _createForOfIteratorHelper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { logger as E } from "../../shared-lib/index.js";
import t from "../common/base-provider.js";
import r from "../managers/braze-instance.js";
import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
import u from "../managers/subscription-manager.js";
import { randomInclusive as l } from "../util/math.js";
import a from "../util/net.js";
import { newFeatureFlagFromJson as at, newFeatureFlagFromSerializedValue as ht } from "./feature-flag-factory.js";
import h from "../util/request-header-utils.js";
var tr = /*#__PURE__*/function (_t) {
  _inherits(tr, _t);
  var _super = _createSuper(tr);
  function tr(t, s, e, i) {
    var _this;
    _classCallCheck(this, tr);
    _this = _super.call(this), _this.h = t, _this.B = s, _this.j = e, _this.C = i, _this.he = [], _this.je = 0, _this.h = t, _this.B = s, _this.j = e, _this.C = i, _this.ye = null, _this.Ce = new u(), _this.S = 10, _this.T = null, _this.I = null, r.q(_this.Ce);
    return _this;
  }
  _createClass(tr, [{
    key: "N",
    value: function N(t) {
      var s;
      if ((null === (s = this.h) || void 0 === s ? void 0 : s.Re()) && null != t && t.feature_flags) {
        this.he = [];
        var _iterator = _createForOfIteratorHelper(t.feature_flags),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _s = _step.value;
            var _t2 = at(_s);
            _t2 && this.he.push(_t2);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        this.je = new Date().getTime(), this.Te(), this.Ce.L(this.he);
      }
    }
  }, {
    key: "De",
    value: function De() {
      var t = {};
      this.j && (t = this.j.lt(s.ct.Ie));
      var e = {};
      for (var _s2 in t) {
        var i = ht(t[_s2]);
        i && (e[i.id] = i);
      }
      return e;
    }
  }, {
    key: "Se",
    value: function Se() {
      var t;
      return (null === (t = this.j) || void 0 === t ? void 0 : t.lt(s.ct.qe)) || {};
    }
  }, {
    key: "Ne",
    value: function Ne(t) {
      this.j && this.j.ft(s.ct.qe, t);
    }
  }, {
    key: "St",
    value: function St(t) {
      return this.Ce.wt(t);
    }
  }, {
    key: "refreshFeatureFlags",
    value: function refreshFeatureFlags(t, s) {
      var _this2 = this;
      var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
      var r = function r() {
        "function" == typeof s && s(), _this2.Ce.L(_this2.he);
      };
      if (!this.ze(e)) return !this.ye && this.h && (this.ye = this.h.Ue(function () {
        _this2.refreshFeatureFlags(t, s);
      })), void r();
      var o = this.B;
      if (!o) return void r();
      i && this.X();
      var n = o.$({}, !0),
        u = o.A(n, h.H.$e);
      var f = !1;
      o.J(n, function () {
        var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
        var o = _this2.B;
        if (!o) return void r();
        var c = new Date().valueOf();
        h.K(_this2.j, h.H.$e, c), -1 !== i && u.push(["X-Braze-Req-Tokens-Remaining", i.toString()]), a.O({
          url: "".concat(o.V(), "/feature_flags/sync"),
          headers: u,
          data: n,
          W: function W(s) {
            if (!o.Y(n, s, u)) return f = !0, void r();
            o.Z(), _this2.N(s), f = !1, "function" == typeof t && t();
          },
          error: function error(t) {
            o._(t, "retrieving feature flags"), f = !0, r();
          },
          tt: function tt(i, r) {
            var a;
            if (f) {
              var _t3 = _this2.T;
              (null == _t3 || _t3 < 1e3 * _this2.S) && (_t3 = 1e3 * _this2.S), a = Math.min(3e5, l(1e3 * _this2.S, 3 * _t3));
            }
            o.st(r, function () {
              _this2.refreshFeatureFlags(t, s, e, !0);
            }, h.H.$e, function (t) {
              return _this2.it(t);
            }, function () {
              return _this2.X();
            }, a);
          }
        });
      }, h.H.$e, s);
    }
  }, {
    key: "X",
    value: function X() {
      null != this.I && (clearTimeout(this.I), this.I = null);
    }
  }, {
    key: "it",
    value: function it(t) {
      this.X(), this.I = t;
    }
  }, {
    key: "ze",
    value: function ze(t) {
      if (!this.h) return !1;
      if (!t) {
        var _t4 = this.h.ke();
        if (null == _t4) return !1;
        var _s3 = !1;
        if (!isNaN(_t4)) {
          if (-1 === _t4) return E.info("Feature flag refreshes not allowed"), !1;
          _s3 = new Date().getTime() >= (this.je || 0) + 1e3 * _t4;
        }
        if (!_s3) return E.info("Feature flag refreshes were rate limited to ".concat(_t4, " seconds")), !1;
      }
      return this.h.Re();
    }
  }, {
    key: "Be",
    value: function Be() {
      var t;
      return (null === (t = this.j) || void 0 === t ? void 0 : t.lt(s.ct.Me)) || null;
    }
  }, {
    key: "Xe",
    value: function Xe() {
      var t, e;
      null === (t = this.j) || void 0 === t || t.ft(s.ct.Me, null === (e = this.C) || void 0 === e ? void 0 : e.bt());
    }
  }, {
    key: "_e",
    value: function _e() {
      var t;
      var s = null === (t = this.C) || void 0 === t ? void 0 : t.bt(),
        e = this.Be();
      return null == e || s === e;
    }
  }, {
    key: "Te",
    value: function Te() {
      if (!this.j) return;
      var t = {};
      var _iterator2 = _createForOfIteratorHelper(this.he),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _s4 = _step2.value;
          var e = _s4.dt();
          t[_s4.id] = e;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this.j.ft(s.ct.Ie, t), this.j.ft(s.ct.Ae, this.je), this.Xe();
    }
  }, {
    key: "changeUser",
    value: function changeUser() {
      this.X();
    }
  }, {
    key: "clearData",
    value: function clearData() {
      this.X();
    }
  }]);
  return tr;
}(t);
export { tr as default };